import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { YEAR, COLLEGE_SINGLE } from '../../../utils/ConstantsMain';
import { isMobile } from 'react-device-detect';
import "../../../pages/Profile/Courses/AddCourses.scss";
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  TextField,
  Button,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const styles = () => ({
  form: {
    padding: 16,
    borderRadius: 4,
    margin: '20px 0 30px 0',
    border: '1px solid #e7e7e7',
  },
  place: {
    maxWidth: 536,
    '@media screen and (max-width: 399.98px)': {
      width: '90%',
    }
  },
  select: {
    borderRadius: 2,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  selectRoot: {
    height: 74,
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  heightSelect: {
    height: 76,
    margin: 0
  },
  nameUniversity: {
    height: 76,
    margin: 0,
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: '536px',
    margin: '0 0 5px',
    "&:last-child": {
      margin: '0 0 -10px'
    }
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    paddingLeft: '8px',
  },
  input_icon: { 
    maxWidth: '560px'
  },
  input_iconCedula: {
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
  },
  input_iconArea: { 
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
    margin: '0 0 -28px 0',
  },
  areaContainer: {
    margin: '0 0 30px 0',
  },
  rootFormControl :{
    display : 'flex',
    alignItems: 'center',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '10px 8px 0',
    padding: 8,
    maxWidth: 232,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },
  tooltipImage: {
    margin: '12px 0 0',
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    margin: 0,
    padding: 0,
    textTransform: 'capitalize',
  },
  autoComplete: {
    display: 'flex',
  },
  autoCompleteTextField: {
    maxWidth: 536,
    margin: '0 0 2px',
    '& .MuiInputLabel-marginDense': {
      transform: 'translate(14px, 16px) scale(1) !important',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
      bottom: 0,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75) !important',
      zIndex: 10,
      right: 'unset',
      backgroundColor: '#fff',
      height: 'fit-content',
    },
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  '@media screen and (max-width: 769px) and (max-width: 1110px)': {
    borderDiv: {
      width: '105%',
    },
  },
  '@media screen and (min-width: 448px) and (max-width: 768.98px)': {
    heightSelect: {
      width: '47%',
    }
  },
  '@media screen and (min-width: 400px) and (max-width: 447.98px)': {
    heightSelect: {
      width: '46%',
    }
  },
  '@media screen and (max-width: 399.98px)': {
    borderDiv: {
      width: '105%',
    },
    nameUniversity: {
      width: '90%',
    },
    TextField: {
      width: '90%',
    },
    heightSelect: {
      width: '41%',
    },
    autoComplete: {
      width: '90%'
    },
  },
  '@media screen and (min-width: 983px) and (max-width: 1179.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (min-width: 769px) and (max-width: 982.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (max-width: 768.98px)': {
    input_iconArea: {
      width: '92%',
      margin: '0 0 22px 0',
      minWidth: '77%'
    },
    input_iconCedula: { 
      minWidth: '77%',
      width: '92%',
    },
    areaContainer: {
      margin: '0 0 -25px 0',
    },
  }
});

const CoursesLawyer = props => {

  const {
    coursesLawyer,
    coursesHelper,
    setFieldValue,
    handleChange,
    handleBlur,
    handleCancel,
    touched,
    errors,
    classes,
    index,
    edit,
  } = props;

  const deleteSubForm = () => {    
    coursesHelper.remove(index)
  }

  // Validate what array to throw in lastYear field

  if (coursesLawyer.firstYear && coursesLawyer.lastYear === '') {
    setFieldValue(`coursesLawyer[${index}].lastYear`, coursesLawyer.firstYear)
  }

  let customName
  if (coursesLawyer.firstYear === '') {
    customName = YEAR[0].name
  } else {
    customName = coursesLawyer.firstYear
  }
  const indexFound = YEAR.findIndex(elem => elem.name === customName)  
  const slicedForLastYear = YEAR.slice(indexFound)

  // Validate what array to throw in firstYear field

  if (coursesLawyer.firstYear === '' && coursesLawyer.lastYear) {
    setFieldValue(`coursesLawyer[${index}].firstYear`, coursesLawyer.lastYear)
  }

  let customName2
  if (coursesLawyer.lastYear === '') {
    customName2 = YEAR[0].name
  } else {
    customName2 = coursesLawyer.lastYear
  }
  const indexFound2 = YEAR.findIndex(elem => elem.name === customName2)  
  const slicedForFirstYear = YEAR.slice(0, indexFound2 + 1)

  // ----------------------------------------------------------------------

  const handleTagSelectSingle = (value, field) => {
    if(value == null) value = ''
    setFieldValue(field, value);
  };

  return (
    <div className={classes.form}>
      <div className={classes.borderDiv}></div>

      <TextField
        name={`coursesLawyer[${index}].name`}
        label="Nombre del curso"
        id={`coursesLawyer[${index}].name`}
        type="text"
        variant="outlined"
        onBlur={handleBlur}
        onChange={handleChange}
        value={coursesLawyer && coursesLawyer.name ? coursesLawyer.name : ''}
        helperText={
          touched &&
          touched.coursesLawyer &&
          touched.coursesLawyer[index] &&
          touched.coursesLawyer[index].name &&
          errors &&
          errors.coursesLawyer &&
          errors.coursesLawyer[index] &&
          errors.coursesLawyer[index].name ?
          errors.coursesLawyer[index].name :
          ''
        }
        error={
          touched &&
          touched.coursesLawyer &&
          touched.coursesLawyer[index] &&
          touched.coursesLawyer[index].name &&
          errors &&
          errors.coursesLawyer &&
          errors.coursesLawyer[index] &&
          errors.coursesLawyer[index].name ?
          true : false
        }
        fullWidth
        className={classes.TextField}
      />

      <Autocomplete
        freeSolo
        multiple={false}
        getOptionLabel={option => option}
        value={coursesLawyer && coursesLawyer.place ? coursesLawyer.place : ''}
        id={`coursesLawyer[${index}].place`}
        options={COLLEGE_SINGLE}
        filterSelectedOptions
        disableCloseOnSelect={false}
        blurOnSelect ={true}
        size={'small'}
        classes={{ root: classes.autoComplete }}
        autoSelect={true}
        onChange={(event, value) => {
          handleTagSelectSingle(value, `coursesLawyer[${index}].place`)
        }}
        renderInput={params => (
          <TextField
            name={`coursesLawyer[${index}].place`}
            type="text"
            InputLabelProps={{ shrink: true }}
            onBlur={handleBlur}
            helperText={
              touched &&
              touched.coursesLawyer &&
              touched.coursesLawyer[index] &&
              touched.coursesLawyer[index].place &&
              errors &&
              errors.coursesLawyer &&
              errors.coursesLawyer[index] &&
              errors.coursesLawyer[index].place ?
              errors.coursesLawyer[index].place :
              ''
            }
            error={
              touched &&
              touched.coursesLawyer &&
              touched.coursesLawyer[index] &&
              touched.coursesLawyer[index].place &&
              errors &&
              errors.coursesLawyer &&
              errors.coursesLawyer[index] &&
              errors.coursesLawyer[index].place ?
              true : false
            }
            {...params}
            classes={{ root: classes.autoCompleteTextField }}
            label="Institución en donde se realizó el curso"
            variant="outlined"
          />
        )}
      />

      <FormControl
        style={{ maxWidth: 256, margin: '0 24px 0 0' }}
        classes={{ root: classes.heightSelect }}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >
          {'Año de inicio'}
        </InputLabel> 
          <Select
            id='firstYear'
            name={`coursesLawyer[${index}].firstYear`}
            value={coursesLawyer && coursesLawyer.firstYear ? coursesLawyer.firstYear : []}
            onChange={handleChange}
          >
            {(!coursesLawyer.lastYear || coursesLawyer.lastYear === '' ?
                YEAR && YEAR.map((item, index) => (
                  <MenuItem key={index} value={item.value} >
                    {item.name}
                  </MenuItem>
                )) :
                coursesLawyer.lastYear ?
                slicedForFirstYear && slicedForFirstYear.map((item, index) => (
                  <MenuItem key={index} value={item.value} >
                    {item.name}
                  </MenuItem>
                )) : null
            )}
        </Select>
        {touched &&
        touched.coursesLawyer &&
        touched.coursesLawyer[index] &&
        touched.coursesLawyer[index].firstYear &&
        errors &&
        errors.coursesLawyer &&
        errors.coursesLawyer[index].firstYear ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.coursesLawyer[index].firstYear}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl>

      <FormControl
        style={{ maxWidth: 256 }}
        classes={{ root: classes.heightSelect }}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >          
          {isMobile ?
            'Año de finalización' :
            'Año de finalización (o previsto)'
          }
        </InputLabel> 
        <Select
          id='lastYear'
          name={`coursesLawyer[${index}].lastYear`}
          value={coursesLawyer && coursesLawyer.lastYear ? coursesLawyer.lastYear : []}
          onChange={handleChange}
        >
          {slicedForLastYear.length === 0 ?
            YEAR && YEAR.map((item, index) => (
              <MenuItem key={index} value={item.value} >
                {item.name}
              </MenuItem>
            )) :
            slicedForLastYear.length !== 0 ?
            (
              slicedForLastYear && slicedForLastYear.map((item, index) => (
              <MenuItem key={index} value={item.value} >
                {item.name}
              </MenuItem>
            ))) :
            null
          }
        </Select>
        {touched.Items && errors.Items ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.Items}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl>

      {!edit && index && index !== 0 ?
        <div style={{width: '100%', display:'flex', justifyContent:'flex-end'}}>
          <Button
              key={index}
              component="span"
              type="button"
              onClick={index && index !== 0 ? deleteSubForm : handleCancel}
              className={classes.deleteAction}
            >
              Eliminar
          </Button>
        </div> : null 
      }

    </div>
  )
};

export default withStyles(styles)(CoursesLawyer);
